import type { DialogsContainerProps } from '@confluence/dialogs/entry-points/DialogsStateContainer.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { EditAttachmentPropertiesDialogProps } from './AttachmentsMacroEditPropertiesDialog.tsx';

export const AttachmentsMacroEditPropertiesDialogLoader: LoadableType<
	EditAttachmentPropertiesDialogProps & DialogsContainerProps
> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-attachments-macro-edit-properties-dialog" */ './AttachmentsMacroEditPropertiesDialog.tsx'
			)
		).EditAttachmentPropertiesDialog,
});
